<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand">{{ routeName }}</a>
      <div class="">
        <ul class="navbar-nav ml-auto">
          <drop-down
            class="nav-item"
            :title="userLogged"
            title-classes="nav-link"
            icon="ti-user"
          >
            <router-link :to="{ path: '/reset' }" class="dropdown-item">Cambiar contraseña</router-link>
            <router-link :to="{ path: '/about-us' }" class="dropdown-item">Acerca de</router-link>
            <a class="dropdown-item"  download="Ayuda.pdf" href="/Ayuda.pdf">Ayuda</a>
            <a class="dropdown-item" @click="logout">Salir</a>
          </drop-down>
        </ul>
      </div>
      <button
        class="navbar-toggler navbar-burger"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
    </div>
  </nav>
</template>
<script>
import auth from '../../token'
export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    userLogged() {
      return auth.getUserLogged();
    }
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    logout () {
      auth.logout();
    }
  },
};
</script>
<style></style>
